import Vue from 'vue';
import Component from 'vue-class-component';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

interface FullScreenDialogOptions {
    title?: string;
    text?: string;
    firstBtnText?: string;
    firstBtnFn?: () => void | Promise<void>;
    secondBtnText?: string;
    secondBtnFn?: () => void | Promise<void>;
}

@WithRender
@Component
export class FullScreenDialogComponent extends Vue {
    visible = false;
    options: FullScreenDialogOptions;

    show(options: FullScreenDialogOptions) {
        this.options = options;
        this.visible = true;
    }

    hide() {
        this.visible = false;
        this.options = {};
    }
}
